module.exports = __webpack_public_path__ + "static/alex-law-db6864e0ed87c37277677db74f3edcf9.jpg";